"use client";

import { ReactComponent as Check } from "../../public/svg/Check.svg";
import React, { useEffect, useRef, useState } from "react";

export function ProgressBarComponent({
  iconStart,
  iconEnd,
  totalSteps = 5,
  currentStep = 1,
  barColor = "#a68aff",
  barBg = "#C9B8FF",
  iconSize = 48,
  stepTitles,
  isDesktop = false,
  hiddenIconStart = true,
}) {
  const safeStep = Math.max(1, Math.min(currentStep, totalSteps));
  const progressRatio = totalSteps <= 1 ? 0 : (safeStep - 1) / (totalSteps - 1);
  let valuePY =
    currentStep === 1
      ? "80px"
      : currentStep === 2
      ? "70px"
      : currentStep === 3
      ? "60px"
      : "40px";

  let valuePX =
    currentStep === 1
      ? "210px"
      : currentStep === 2
      ? "160px"
      : currentStep === 3
      ? "110px"
      : "40px";
  const easedProgress = Math.pow(progressRatio, 0.9);
  const iconTranslateY = `calc(${(1 - progressRatio) * 100}% - ${valuePY})`;
  const mobileTranslateX = `calc(${easedProgress * 100}% - ${valuePX})`;

  const completeStep = currentStep === totalSteps;
  const [showFinish, setShowFinish] = useState(false);
  const timeoutRef = useRef();
  const stepRefs = useRef([]);

  const containerRef = useRef(null);
  const [, setContainerWidth] = useState(0);

  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  useEffect(() => {
    if (completeStep) {
      timeoutRef.current = setTimeout(() => setShowFinish(true), 100);
    } else {
      setShowFinish(false);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [completeStep]);

  useEffect(() => {
    if (!containerRef.current) return;

    const updateWidth = () => {
      setContainerWidth(containerRef.current.offsetWidth);
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (isDesktop) {
    return (
      <div
        className="relative flex flex-col-reverse items-center justify-between"

        style={{
          position: "absolute",
          top: "clamp(150px, 6vw, 200px)",
          left: 300,
          height: "-webkit-fill-available",
          marginBottom: "clamp(50px, 3vw, 80px)",
        }}
      >
        {hiddenIconStart && (
          <div
            className="absolute left-1/2 pointer-events-none"
            style={{
              top: 0,
              bottom: 0,
              transform: `translate(-50%, ${iconTranslateY})`,
              transition: "transform 2s cubic-bezier(0.22, 1, 0.36, 1)",
              willChange: "transform",
              zIndex: 1,
            }}
          >
            <div
              style={{
                width: "clamp(5rem, 4vw, 20rem)",
                height: "clamp(5rem, 4vw, 20rem)",
                rotate: "270deg",
                zIndex: 1,
              }}
            >
              {iconStart}
            </div>
          </div>
        )}

        {steps.map((step) => {
          const isFirst = step === 1;
          const isLast = step === totalSteps;
          const isCompleted = step < safeStep;
          const isCurrent = step === safeStep;
          const isActive = step <= safeStep;

          return (
            <React.Fragment key={step}>
              {!isFirst && (
                <div
                  className="flex-1 duration-700"
                  style={{
                    width: "0.1rem",
                    background: isActive
                      ? barColor
                      : "linear-gradient(270deg, rgba(201,184,255,.4) 80%, transparent)",
                    transition: "background-color 300ms, box-shadow 300ms",
                  }}
                />
              )}

              {!isLast && (
                <div className="relative flex items-center justify-center mb-3">
                  {/* Texto */}
                  <div className="absolute right-20 w-20 text-right">
                    <span className="text-white text-sm font-medium">
                      {stepTitles[step - 1]}
                    </span>
                  </div>

                  {/* Círculos */}
                  <div
                    ref={(el) => (stepRefs.current[step] = el)}
                    className="relative rounded-full"
                    style={{
                      width: "clamp(50px,4vw,70px)",
                      height: "clamp(50px,4vw,70px)",
                      background: "#29214F",
                      transition: "background-color 300ms, box-shadow 300ms",
                    }}
                  >
                    <div
                      className="absolute rounded-full"
                      style={{
                        width: "clamp(35px,3vw,55px)",
                        height: "clamp(35px,3vw,55px)",
                        background: "#565584",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                      }}
                    />

                    <div
                      className="absolute flex items-center justify-center rounded-full"
                      style={{
                        width: "clamp(20px,2vw,35px)",
                        height: "clamp(20px,2vw,35px)",
                        background:
                          isCompleted || isCurrent ? "#A68AFF" : "#687099",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                        boxShadow:
                          (isCompleted || isCurrent) && "0 0 8px #A68AFF",
                        transition: "background-color 300ms, box-shadow 300ms",
                      }}
                    >
                      {/*                       {isCurrent && (
                        <div
                          className="absolute z-40 pointer-events-none"
                          style={{
                            left: "50%",
                            transform: `
                              translateX(-50%)
                            `,
                            transition:
                              "transform 900ms cubic-bezier(0.22, 1, 0.36, 1)",
                          }}
                        >
                          <div
                            style={{
                              width: "clamp(5rem, 4vw, 20rem)",
                              height: "clamp(5rem, 4vw, 20rem)",
                              rotate: "270deg",
                            }}
                          >
                            {iconStart}
                          </div>
                        </div>
                      )} */}

                      {isCurrent && (
                        <div className="opacity-0 pointer-events-none" />
                      )}

                      {isCompleted && <Check className="w-5 h-5" />}
                      {!isCompleted && !isCurrent && (
                        <span className="text-tgray font-semibold">
                          {step}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* FINAL */}
              {isLast && (
                <div
                  className="relative flex items-center justify-center"
                  style={{ width: iconSize, height: iconSize }}
                >
                  <span
                    style={{
                      position: "absolute",
                      opacity: showFinish ? 0 : 1,
                      transition: "opacity .7s",
                    }}
                  >
                    {iconEnd}
                  </span>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  // 📱 VISTA MÓVIL (HORIZONTAL — SIN CAMBIOS)
  return (
    <div className="sticky w-full">
      <div className="relative flex items-center justify-between">
        {hiddenIconStart && (
          <div
            className="absolute left-1/2 pointer-events-none"
            style={{
              top: 0,
              bottom: 0,
              transform: `translate(${mobileTranslateX}, 0% )`,
              transition: "transform 2s cubic-bezier(0.22, 1, 0.36, 1)",
              willChange: "transform",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: "clamp(5rem, 4vw, 20rem)",
                height: "clamp(5rem, 4vw, 20rem)",
                zIndex: 9999,
              }}
            >
              {iconStart}
            </div>
          </div>
        )}

        {steps.map((step) => {
          const isFirst = step === 1;
          const isLast = step === totalSteps;
          const isCompleted = step < currentStep;
          const isCurrent = step === currentStep;
          const isActive = step <= currentStep;

          return (
            <React.Fragment key={step}>
              {!isFirst && (
                <div
                  className="flex-1 duration-700"
                  style={{
                    background: isActive ? barColor : barBg,
                    height: "0.1rem",
                    transition: "background-color 300ms, box-shadow 300ms",
                  }}
                />
              )}

              {!isLast && (
                <div className="relative flex items-center justify-center">
                  <div
                    className="absolute rounded-full duration-700"
                    style={{
                      width: 42,
                      height: 42,
                      backgroundColor: isCurrent ? "#29214fc7" : "#29214F",
                      transition: "background-color 300ms, box-shadow 300ms",
                    }}
                  />

                  <div
                    className="absolute rounded-full duration-700"
                    style={{
                      width: 32,
                      height: 32,
                      background: "#565584",
                      boxShadow: "0px 0px 5px 0px #00000091",
                      transition: "background-color 300ms, box-shadow 300ms",
                    }}
                  />

                  <div
                    className="absolute rounded-full duration-700 flex items-center justify-center"
                    style={{
                      width: 22,
                      height: 22,
                      background: isCurrent
                        ? "#A68AFF"
                        : isCompleted
                        ? "#A68AFF"
                        : "#687099",
                      boxShadow:
                        isCompleted &&
                        "0.5px 1px 1px 0px #C9B8FF inset, -0.5px -1px 1px 0px #00000040 inset,  0px 0px 7.3px 1px #A68AFF",
                      transition: "background-color 300ms, box-shadow 300ms",
                    }}
                  >
                    {/* {isCurrent && (
                      <div
                        className="absolute -top-2 duration-700 ease-in-out"
                        style={{
                          width: iconSize,
                          height: iconSize,
                          transition:
                            "background-color 300ms, box-shadow 300ms",
                        }}
                      >
                        <div className="relative flex items-center justify-center">
                          {iconStart}
                        </div>
                      </div>
                    )}
 */}
                    {isCompleted && <Check className="w-4 h-4" />}

                    {!isCurrent && !isCompleted && (
                      <div
                        className="relative z-10 flex items-center justify-center font-semibold duration-700"
                        style={{
                          fontSize: 15,
                          color: "#BEBCC2",
                          transition:
                            "background-color 300ms, box-shadow 300ms",
                        }}
                      >
                        {step}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {isLast && (
                <div
                  className="relative flex items-center justify-center duration-700"
                  style={{
                    width: iconSize,
                    height: iconSize,
                    fontSize: iconSize,
                    transition: "background-color 300ms, box-shadow 300ms",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      transition: "opacity 0.7s",
                      opacity: showFinish ? 0 : 1,
                      height: "3.5rem",
                    }}
                  >
                    {iconEnd}
                  </span>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <style>
        {`
          @keyframes icon-bounce {
            0% { transform: translateY(0px); }
            100% { transform: translateY(5px); }
          }
        `}
      </style>
    </div>
  );
}
